"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCommentIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const AddCommentIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "8 8 32 32" }),
    react_1.default.createElement("path", { d: "M30.7929 23L17.2071 23C16.7617 23 16.5386 22.4614 16.8536 22.1464L23.6464 15.3536C23.8417 15.1583 24.1583 15.1583 24.3536 15.3536L31.1464 22.1464C31.4614 22.4614 31.2383 23 30.7929 23Z" }),
    react_1.default.createElement("rect", { x: "22", y: "33", width: "12", height: "4", rx: "0.5", transform: "rotate(-90 22 33)" })));
exports.AddCommentIcon = AddCommentIcon;
exports.default = exports.AddCommentIcon;
